import { get } from 'config/api/config';

const THEME_COLORS = '/viewer/theme/website-theme-colors';
const WEBSITE_MEDIA = '/viewer/theme/website-media';

type BrandRequestParams = {
  websiteId: number;
  orgId: number;
};

export const getBrandingColors = async (data: BrandRequestParams) => {
  const { websiteId, orgId } = data;
  const response = await get(THEME_COLORS, {
    params: {
      websiteId,
      orgId,
    },
  });
  return response;
};

export const getBrandingMedia = async (data: BrandRequestParams) => {
  const { websiteId, orgId } = data;
  const response = await get(WEBSITE_MEDIA, {
    params: {
      websiteId,
      orgId,
    },
  });
  return response;
};
